export enum PopupType {
    alert,
    confirm
}